import {
    Backdrop,
    Box,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    Modal,
    Tooltip,
    Typography
} from "@mui/material"
import React, { useEffect, useState } from "react"
import CloseIcon from '@mui/icons-material/Close'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import ModalPreviewImage from '../reportAccident/ModalPreviewImage'
import httpReq from "../../../ce-services/http-req"
import * as lod from 'lodash'

const ModalVisMarkerInfo = ({data, type, setData, isMobile}) => {
    const keys = Object.keys(data || {}).filter(key => {
        return key !== 'id' && key !== 'workStartDateTime' && key !== 'workCompletedDateTime'
    })
    const [attachments, setAttachments] = useState([])
    const [photoPreview, setPhotoPreview] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        getAttachments()
    }, [type, data])

    const getAttachments = async () => {
        setIsLoading(true)
        if (type === 'crash details') {
            const res = await httpReq('PublicAccidentAttachment/GetList/' + data.id, 'GET', null, false)
            console.log('res ... ', res.responseData)
            if (!res.responseAnyError && res.responseData.length > 0) {
                const a = res.responseData.map(async dt => {
                    const res = await httpReq(`PublicAccidentAttachment/Get/${dt.id}`, 'GET', null, true)
                    return res.responseData
                })
                const pool = await Promise.all(a)
                const dataToSave = pool.map((attachment, k) => {
                    const base64 = `data:${attachment.fileType};base64,${attachment.fileContent}`
                    attachment.base64 = base64
                    return attachment
                })
                setAttachments(dataToSave)
            }
        } else if (type === 'report details') {
            const resLogBook = await httpReq(`ReportEvent/GetList/${data.id}`, 'GET', null, true)
            // console.log('resLogBook', resLogBook)
            if (!resLogBook.responseAnyError && resLogBook.responseData.length > 0) {
                const firstLogBook = resLogBook.responseData[0]
                // console.log('firstLogBook', firstLogBook)
                if (firstLogBook) {
                    const resAttachmentsFirstLogBook = await httpReq(`/ReportEventAttachment/GetList/${firstLogBook.id}`, 'GET', null, true)
                    if (!resAttachmentsFirstLogBook.responseAnyError) {
                        const dataWithFileContent = resAttachmentsFirstLogBook.responseData.map(async (d) => {
                            const a = await httpReq(`/ReportEventAttachment/Get/${d.id}`, 'GET', null, true);
                            if (!a.responseAnyError) {
                                return a.responseData
                            }
                        })
                        const pool = await Promise.all(dataWithFileContent)
                        const dataToSave = pool.map((attachment, k) => {
                            const base64 = `data:${attachment.fileMimeType}${attachment.fileExtension};base64,${attachment.fileContent}`
                            // console.log('base64 ---> ', base64)
                            attachment.base64 = base64
                            return attachment
                        })
                        setAttachments(dataToSave)
                    }
                }
            }
        }
        setIsLoading(false)
    }

    console.log('attachments ', attachments)

    return (
        <Modal sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} open={!!data}>
            <Card
                sx={{
                    width: isMobile ? '100%' : '40%',
                    height: '100%',
                    overflowY: 'auto',
                    borderRadius: isMobile ? 0 : 2,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 3,
                        py: 2,
                    }}
                >
                    <Typography variant="h6" sx={{fontWeight: 600}}>
                        {`View ${type}`}
                    </Typography>
                    <IconButton onClick={() => setData(null)} color="primary">
                        <CloseIcon/>
                    </IconButton>
                </Box>

                {/* Content */}
                <CardContent sx={{flex: 1}}>
                    <Grid container >
                        {keys.map((key, index) => {
                            const value = data[key];

                            const renderLabelValue = (label, content) => (
                                <>
                                    <Grid item xs={4} key={index}
                                          sx={{

                                              alignItems: 'center',
                                              borderBottom: index + 1 !== keys.length && '1px solid lightgray',
                                              borderRight: index + 1 !== keys.length && '1px solid lightgray',
                                              padding: 1
                                          }}>
                                        <Typography sx={{
                                            fontWeight: 'bold',
                                            color: 'text.secondary',
                                            fontSize: 13
                                        }}>{label}</Typography>

                                    </Grid>
                                    <Grid item xs={8} sx={{borderBottom: index + 1 !== keys.length && '1px solid lightgray',alignItems: 'center',display:'flex',pl:1}}>
                                        <Typography sx={{fontSize: 13}}>{content}</Typography>
                                    </Grid>
                                </>
                            );

                            // Custom fields
                            if (key === 'code') return renderLabelValue('Id', value)
                            if (key === 'title') return renderLabelValue('Title', value)
                            if (key === 'description') return renderLabelValue('Description', value)
                            if (key === 'reportDateTime') return renderLabelValue('Report date and time', value)
                            if (key === 'expenditure') return renderLabelValue('Expenditure [local currency]', value)
                            if (key === 'fundingSource') return renderLabelValue('Funding source', value)
                            if (key === 'firstName') return renderLabelValue('First name', value)
                            if (key === 'lastName') return renderLabelValue('Last name', value)
                            if (key === 'phoneNumber') return renderLabelValue('Phone number', value)
                            if (key === 'email') return renderLabelValue('Email', value)
                            if (key === 'region' && value?.name) return renderLabelValue('Region', value.name);
                            if (key === 'longitude') return renderLabelValue('Longitude', value);
                            if (key === 'latitude') return renderLabelValue('Latitude', value);
                            if (key === 'reportType' && value?.name) return renderLabelValue('Report Type', value.name);
                            if (key === 'reporter' && value?.completeName) return renderLabelValue('Reporter', value.completeName);
                            if (key === 'manager') return renderLabelValue('Report assigned to', value?.completeName || 'No manager');

                            if (key === 'reportEvents') return null;

                            if (key === 'tagValues' && Array.isArray(value)) {
                                const v = [...lod.orderBy(value, ['tagValue.tag.orderIndex'], 'asc')]
                                return (
                                    <Box sx={{mt:2}} key={index}>
                                        <Typography
                                            sx={{
                                                fontWeight: 'bold',
                                                color: 'text.secondary',
                                                mb: 1
                                            }}>{'Tags'}</Typography>
                                        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                                            {v.map((event, i) => {
                                                return (
                                                    <Chip
                                                        key={i}
                                                        label={event.tagValue.tag.name + ' - ' + event.tagValue.value}
                                                        sx={{backgroundColor: event.tagValue.color, color: '#fff'}}
                                                    />
                                                )
                                            })}
                                        </Box>
                                    </Box>
                                );
                            }

                            if (key === 'vehicles' && Array.isArray(value)) {
                                return (
                                    <Box key={index} sx={{borderBottom: '1px solid lightgray', padding: 1,width:'100%'}}>
                                        <Typography
                                            sx={{
                                                fontWeight: 'bold',
                                                color: 'text.secondary',
                                                mb: 1
                                            }}>{'Vehicles involved'}</Typography>
                                        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 2}}>
                                            {value.map((vehicle, i) => (
                                                <Typography sx={{fontSize:13}} key={i}>
                                                    {vehicle.admount} × {vehicle.vehicleType?.name}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </Box>
                                );
                            }

                        })}
                        <>
                            {attachments.length > 0 &&
                                <Box sx={{width:'100%',mt:2}}>
                                    <Typography
                                        sx={{
                                            fontWeight: 'bold',
                                            color: 'text.secondary',
                                            mb: 1
                                        }}>{'Attachments'}</Typography>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        overflowY: 'auto',
                                        maxHeight: '30vh'
                                    }}>

                                        {attachments.map((att, i) => (
                                            <React.Fragment key={i}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        px:0.5,
                                                        borderRadius: 1,
                                                        backgroundColor: '#f5f5f5',
                                                    }}
                                                >
                                                    <Typography sx={{
                                                        color: 'black',
                                                        fontSize:13
                                                    }}>{att.fileName}</Typography>
                                                    <Tooltip title="View">
                                                        <IconButton onClick={() => setPhotoPreview(att)}
                                                                    color="primary">
                                                            <OpenInFullIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                                {i < attachments.length - 1 && <Divider/>}
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                </Box>
                            }
                        </>
                    </Grid>
                </CardContent>

                {/* Loading & Preview */}
                {isLoading && (
                    <Backdrop sx={{color: '#fff', zIndex: 1000}} open={isLoading}>
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                )}
                {!!photoPreview && (
                    <ModalPreviewImage isMobile={isMobile} image={photoPreview} setImage={setPhotoPreview}/>
                )}
            </Card>
        </Modal>
    )
}

export default ModalVisMarkerInfo